document.addEventListener('DOMContentLoaded', function () {

    var inspSearch = document.querySelector('#inspirationSearch');
    if (inspSearch) {
        inspSearch.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelectorAll('.insp-pager[data-type=blog]').forEach(function(p){
                p.dataset.pageapi = '0';
                p.dataset.maxreached = 'false';
            });
            InspirationSyncItems('search', 'blog');
        });
    }

    function formatYMD(d) {
        if (!d || isNaN(d.getTime())) return '';
        var yyyy = d.getFullYear();
        var mm = ('0' + (d.getMonth() + 1)).slice(-2);
        var dd = ('0' + d.getDate()).slice(-2);
        return yyyy + '-' + mm + '-' + dd;
    }

    // Initialize Litepicker on elements with class .blog-date
    document.querySelectorAll('.blog-date').forEach(function(el){
        try {
            if (typeof Litepicker === 'undefined') return;

            var picker = new Litepicker({
                element: el,
                singleMode: false,
                autoApply: true,
                format: 'DD MMM YYYY'
            });

            // If there are hidden inputs with existing values, set them as the initial range
            var startInput = document.getElementById('blogStartDate');
            var endInput = document.getElementById('blogEndDate');
            if (startInput && endInput && startInput.value && endInput.value) {
                // Expecting values like 'YYYY-MM-DD 00:00:00' so take the date part
                var s = startInput.value.split(' ')[0];
                var eVal = endInput.value.split(' ')[0];
                var sDate = new Date(s);
                var eDate = new Date(eVal);
                try { picker.setDateRange(sDate, eDate); } catch (err) { /* ignore */ }

                // Update visible text similar to original behaviour (without year)
                if (!isNaN(sDate.getTime()) && !isNaN(eDate.getTime())) {
                    el.innerHTML = sDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + eDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
                }
            }

            picker.on('selected', function(startDate, endDate) {
                var sd = new Date(startDate.getTime());
                var ed = new Date(endDate.getTime());

                if (sd && ed) {
                    // Format visible value without the year
                    try {
                        // Set the output
                        el.innerHTML = sd.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + ed.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });

                        var blogStart = formatYMD(sd);
                        var blogEnd = formatYMD(ed);
                        if (startInput) startInput.value = blogStart ? (blogStart + ' 00:00:00') : '';
                        if (endInput) endInput.value = blogEnd ? (blogEnd + ' 23:59:59') : '';
                    } catch (err) { /* ignore */ }
                }

                // Reset pager and re-run search
                document.querySelectorAll('.insp-pager[data-type=blog]').forEach(
                    function(p) {
                        p.dataset.pageapi = '0';
                        p.dataset.maxreached = 'false';
                    }
                );
                InspirationSyncItems('search', 'blog');
            });
        } catch (e) {
            console.error('Litepicker init error', e);
        }
    });

    // Pager arrow handlers
    document.querySelectorAll('.insp-pager .left-arrow').forEach(function(btn){
        btn.addEventListener('click', function () {
            if (!btn.classList.contains('disabled')) {
                var currentPager = btn.closest('.insp-pager');

                var listPage = (parseInt(currentPager.dataset.pageapi || '0', 10) || 0) - 1;
                if (listPage >= 0) {
                    currentPager.dataset.pageapi = String(listPage);
                    InspirationSyncItems('search', currentPager.dataset.type);
                }
            }
        });
    });

    document.querySelectorAll('.insp-pager .right-arrow').forEach(function(btn){
        btn.addEventListener('click', function () {
            if (!btn.classList.contains('disabled')) {
                var currentPager = btn.closest('.insp-pager');

                var listPage = (parseInt(currentPager.dataset.pageapi || '0', 10) || 0) + 1;
                currentPager.dataset.pageapi = String(listPage);
                InspirationSyncItems('search', currentPager.dataset.type);
            }
        });
    });

});

function InspirationSyncItems(origin, carouselID) {

    var currentPager = document.querySelector('.insp-pager[data-type="' + carouselID + '"]');

    var apiEl = document.querySelector('.inspiration-content');
    var apiPath = apiEl ? apiEl.dataset.api : '';

    var pageNumber = currentPager ? (parseInt(currentPager.dataset.page || '0', 10) || 0) : 0;
    var pageSize = currentPager ? (parseInt(currentPager.dataset.pagesize || '0', 10) || 0) : 0;
    var pageApi = currentPager ? (parseInt(currentPager.dataset.pageapi || '0', 10) || 0) : 0;
    var pageSizeApi = currentPager ? (parseInt(currentPager.dataset.pagesizeapi || '0', 10) || 0) : 0;
    var maxReached = currentPager ? (currentPager.dataset.maxreached === 'true') : false;

    var cityEl = document.getElementById('city');
    var personaEl = document.getElementById('persona');
    var city = cityEl ? cityEl.value : '';
    var persona = personaEl ? personaEl.value : '';

    var blogStartDateEl = document.getElementById('blogStartDate');
    var blogEndDateEl = document.getElementById('blogEndDate');
    var blogStartDate = blogStartDateEl ? blogStartDateEl.value : '';
    var blogEndDate = blogEndDateEl ? blogEndDateEl.value : '';

    var apiUrl = apiPath + "?api=true"
        + (pageNumber > 0 ? "&page=" + pageNumber : "")
        + (pageSize > 0 ? "&pageSize=" + pageSize : "")
        + (pageApi > 0 ? "&pageApi=" + pageApi : "")
        + (pageSizeApi > 0 ? "&pageSizeApi=" + pageSizeApi : "")
        + (city != "" ? "&destination=" + encodeURIComponent(city) : "")
        + (persona != "" ? "&persona=" + encodeURIComponent(persona) : "")
        + (blogStartDate != "" ? "&blogStartDate=" + encodeURIComponent(blogStartDate) : "")
        + (blogEndDate != "" ? "&blogEndDate=" + encodeURIComponent(blogEndDate) : "");

    fetch(apiUrl, { method: 'GET' })
        .then(function (resp) { return resp.text(); })
        .then(function (data) {
            try {
                var temp = document.createElement('div');
                temp.innerHTML = data;
                var itemsEl = temp.querySelector('.insp-items[data-type="blog"]');
                var maxReachedVal = itemsEl ? itemsEl.dataset.maxreached : undefined;
                if (currentPager && maxReachedVal !== undefined) currentPager.dataset.maxreached = String(maxReachedVal);

                var newFullCount = itemsEl ? itemsEl.dataset.fullcount : undefined;
                newFullCount = (newFullCount === undefined) ? 0 : parseInt(newFullCount, 10) || 0;
                if (currentPager) currentPager.dataset.fullcount = String(newFullCount);

                if (newFullCount === 0) {
                    document.querySelectorAll('.nr-blog').forEach(function(nb){ nb.classList.add('active'); });
                    var target = document.querySelector('.insp-items[data-type="blog"]');
                    if (target) target.innerHTML = '';
                    document.querySelectorAll('.insp-pager[data-type=blog]').forEach(function(p){ p.style.display = 'none'; });
                } else {
                    document.querySelectorAll('.nr-blog').forEach(function(nb){ nb.classList.remove('active'); });
                    document.querySelectorAll('.insp-pager[data-type=blog]').forEach(function(p){ p.style.display = ''; });

                    var itemList = itemsEl ? itemsEl.querySelectorAll('.insp-item') : [];
                    var container = document.querySelector('.insp-items[data-type="blog"]');
                    if (container) {
                        var html = '';
                        itemList.forEach(function(it){ html += it.outerHTML; });
                        container.innerHTML = html;
                    }

                    if (currentPager && (currentPager.dataset.maxreached === 'true' || currentPager.dataset.maxreached === true)) {
                        var right = currentPager.querySelector('.right-arrow'); if (right) right.classList.add('disabled');
                    } else if (currentPager) { var right = currentPager.querySelector('.right-arrow'); if (right) right.classList.remove('disabled'); }

                    var currentPage = currentPager ? (parseInt(currentPager.dataset.pageapi || '0', 10) || 0) : 0;
                    if (currentPager) {
                        var left = currentPager.querySelector('.left-arrow');
                        if (currentPage == 0) { if (left) left.classList.add('disabled'); } else { if (left) left.classList.remove('disabled'); }
                    }

                }

            } catch (err) { console.error('InspirationSyncItems parse error', err); }
        }
    )
    .catch(function (err) { console.error(err); });
}


